import { Timestamp } from "../../google/protobuf/timestamp";
import { Duration } from "../../google/protobuf/duration";
import * as _m0 from "protobufjs/minimal";
import { toTimestamp, fromTimestamp } from "@osmonauts/helpers";
/** Params defines the claim module's parameters. */

function createBaseParams() {
  return {
    airdrops: []
  };
}
export const Params = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.airdrops) {
      Airdrop.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdrops.push(Airdrop.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdrops;
    const message = createBaseParams();
    message.airdrops = ((_object$airdrops = object.airdrops) === null || _object$airdrops === void 0 ? void 0 : _object$airdrops.map(e => Airdrop.fromPartial(e))) || [];
    return message;
  }
};
function createBaseAirdrop() {
  return {
    airdropIdentifier: "",
    airdropStartTime: undefined,
    airdropDuration: undefined,
    claimDenom: "",
    distributorAddress: "",
    claimedSoFar: ""
  };
}
export const Airdrop = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    if (message.airdropStartTime !== undefined) {
      Timestamp.encode(toTimestamp(message.airdropStartTime), writer.uint32(18).fork()).ldelim();
    }
    if (message.airdropDuration !== undefined) {
      Duration.encode(message.airdropDuration, writer.uint32(26).fork()).ldelim();
    }
    if (message.claimDenom !== "") {
      writer.uint32(34).string(message.claimDenom);
    }
    if (message.distributorAddress !== "") {
      writer.uint32(42).string(message.distributorAddress);
    }
    if (message.claimedSoFar !== "") {
      writer.uint32(50).string(message.claimedSoFar);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirdrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        case 2:
          message.airdropStartTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          break;
        case 3:
          message.airdropDuration = Duration.decode(reader, reader.uint32());
          break;
        case 4:
          message.claimDenom = reader.string();
          break;
        case 5:
          message.distributorAddress = reader.string();
          break;
        case 6:
          message.claimedSoFar = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti, _object$airdropStartT, _object$airdropDurati, _object$claimDenom, _object$distributorAd, _object$claimedSoFar;
    const message = createBaseAirdrop();
    message.airdropIdentifier = (_object$airdropIdenti = object.airdropIdentifier) !== null && _object$airdropIdenti !== void 0 ? _object$airdropIdenti : "";
    message.airdropStartTime = (_object$airdropStartT = object.airdropStartTime) !== null && _object$airdropStartT !== void 0 ? _object$airdropStartT : undefined;
    message.airdropDuration = (_object$airdropDurati = object.airdropDuration) !== null && _object$airdropDurati !== void 0 ? _object$airdropDurati : undefined;
    message.claimDenom = (_object$claimDenom = object.claimDenom) !== null && _object$claimDenom !== void 0 ? _object$claimDenom : "";
    message.distributorAddress = (_object$distributorAd = object.distributorAddress) !== null && _object$distributorAd !== void 0 ? _object$distributorAd : "";
    message.claimedSoFar = (_object$claimedSoFar = object.claimedSoFar) !== null && _object$claimedSoFar !== void 0 ? _object$claimedSoFar : "";
    return message;
  }
};